export default "__VITE_ASSET__Bs3INo8A__"